/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getList = (buildingId, payload, callback) =>
  req.list(
    c.GET_ASSESSMENT_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_property_assessments?isPaginate=1`,
    payload,
    ({ res }) => {
      const { data } = res.data;
      const { total_appraised_value, total_area, total_assessed_value, total_assessment_level, total_depreciation, total_market_value } = res;

      if (callback) callback({ data, total_appraised_value, total_area, total_assessed_value, total_assessment_level, total_depreciation, total_market_value })
    }
  );

export const showData = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_ASSESSMENT_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_property_assessments/${id}`,
    payload,
    callback
  );

export const getCodedValueList = (payload, callback) =>
  req.list(
    c.GET_CODED_VALUE_LIST,
    '/api/v1/rpt/administrator/settings/tax_exempt_codes?status=1',
    payload,
    callback
  );

export const updateBuildingPropertyAssessment = (
  id,
  buildingPropertAssessmentId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_BUILDING_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_property_assessments/${buildingPropertAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );
